<template>
  <div class="username-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control" type="text"
          :id="options.name"
          :value="value"
          :name="options.name"
          @input="validateField($event.target.value)"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Api from '@/vuex/api'
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'UsernameInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          unique: false,
          required: false
        }
      }
    }
  },
  data () {
    return {
      regex: /[^a-zA-Z0-9@_.-]|\.{2,}/,
      isValid: false,
      isDirty: false,
      isUnique: true,
      isLength: true,
      isLoading: false,
      isRegex: true,
      delayedValidate: false,
      minLength: 5
    }
  },
  computed: {
    validationClass,
    validationMessage,
    validationIcon,
    invalidMessage () {
      if (this.options.unique && !this.isUnique) {
        return this.options.label + ' is already taken'
      } else if (!this.isLength && this.value) {
        return this.options.label + ' must be at least ' + this.minLength + ' characters long'
      } else if (this.value && !this.isRegex) {
        return this.options.label + ' may only contain letters, numbers, ' +
        'single consecutive full stops and underscores'
      } else {
        return this.options.label + ' is required'
      }
    }
  },
  mounted () {
    if (this.options.minLength) {
      this.minLength = this.options.minLength
    }
  },
  methods: {
    async checkUsername () {
      this.isLoading = true
      try {
        let instance = new Api()
        let data = await instance.checkUsername({
          checkVal: this.value, ignoreVal: this.options.ignore
        })
        this.isLoading = false
        this.isUnique = this.isValid = data.unique
      } catch (e) {
        this.isLoading = false
        this.isUnique = false
        this.isValid = false
      }
    },
    validateField (val = this.value) {
      this.$emit('input', val)
      if (this.delayedValidate) {
        this.delayedValidate.cancel()
        this.delayedValidate = false
      }
      this.delayedValidate = _.debounce(async (val) => {
        await this.checkUsername()
      }, 1500, { 'leading': false, 'trailing': true })
      this.validate(val)
      if (this.options.unique && this.isValid) {
        this.delayedValidate(val)
      }
    },
    validate (val = this.value) {
      if (val) {
        this.isDirty = true
        this.isLength = this.isValid = val.length >= this.minLength
        if (this.isLength) {
          this.isRegex = this.isValid = !new RegExp(this.regex).test(val)
        }
      } else if (this.options.required) {
        this.isValid = false
        this.isDirty = true
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/UsernameInput.vue